import React from "react"

function EmailLink(props) {
  const { email } = props

  return <span className="email-link">&nbsp;<a href={`mailto:${email}`}>{email}</a></span>
}

export default EmailLink
